import { Text, Image, Card, Link } from '@atoms/index';
import { callToNumber, mailToGmail } from '@helpers/miscelleanous';

const ContactCard = ({ icon, label, value, type }) => {
    const getContactValue = (type, value) => {
        switch (type) {
            case 'phone':
                return <Link href={callToNumber(value)} children={value} />;
            case 'email':
                return (
                    <Link
                        href={mailToGmail(value)}
                        children={value}
                        target="_blank"
                    />
                );
            default:
                return value;
        }
    };

    return (
        <Card
            className="flex gap-6 flex-1"
            paddingClass="px-4 py-3 md:px-3 md:py-4 lg:px-6"
            shadow="shadow-custom-xs"
            borderRadiusClass='rounded-lg'
        >
            <div className="flex gap-2">
                <div className='flex justify-center items-center w-6 h-6'>
                <Image src={icon} className="w-5 h-6" /></div>
                <div className="flex flex-col gap-1 flex-1">
                    <Text
                        className="p4-regular text-gray-600"
                        content={label}
                    />
                    <Text
                        className="text-primary-500 p4-medium max-w-[440px]"
                        content={getContactValue(type, value)}
                    />
                </div>
            </div>
        </Card>
    );
};

export default ContactCard;
